import format from 'date-fns/format';
import secondsToMinutes from 'date-fns/secondsToMinutes';
import isValid from 'date-fns/isValid';
import addMinutes from 'date-fns/addMinutes';
import { formatDistanceToNowStrict } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';

const secondsToMins = (seconds) => secondsToMinutes(Number(seconds));
const isValidDate = (date) => {
    return isValid(new Date(date));
};
const getDiffInDays = (date) => {
    const now = new Date();
    const diffInMilliseconds = Math.abs(now.getTime() - date.getTime());
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 3600 * 24));
    return diffInDays;
};
const formatDateFromUTC = (date, dateFormat) => {
    return format(addMinutes(date, date.getTimezoneOffset()), dateFormat);
};
const formatRelativeDateAndTime = (date) => {
    const diffInDays = getDiffInDays(date);
    if (diffInDays <= 7) {
        if (diffInDays === 0) {
            return formatDistanceToNowStrict(date, { addSuffix: true });
        }
        else if (diffInDays === 1) {
            return `Yesterday ${format(date, "p")}`;
        }
        else {
            return `${formatDistanceToNowStrict(date, { addSuffix: true })} ${format(date, "p")}`;
        }
    }
    else {
        return format(date, "MMM d, yyyy");
    }
};
const getTimezoneOffsetWithDST = (timeZone, date) => {
    const timezoneOffset = getTimezoneOffset(timeZone, date);
    // Calculate the hours and minutes offset
    const offsetHours = Math.floor(Math.abs(timezoneOffset) / (1000 * 60 * 60));
    const offsetMinutes = Math.abs(timezoneOffset) % (1000 * 60 * 60);
    // Determine the sign of the offset
    const offsetSign = timezoneOffset < 0 ? "-" : "+";
    // Format the offset as +/-HH:mm
    const offsetFormat = `${offsetSign}${String(offsetHours).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
    return offsetFormat;
};
const getISOFormattedDate = (date) => {
    if (date.includes("/")) {
        const [month, day, year] = date.split("/");
        return [year, month, day].join("-");
    }
    return date;
};

export { formatDateFromUTC, formatRelativeDateAndTime, getDiffInDays, getISOFormattedDate, getTimezoneOffsetWithDST, isValidDate, secondsToMins };
